export const EDOS_LIST = "/api/edoslist";
export const DISEASE_NAME = "/api/diseaseName";
export const SAMPLE_TYPE = "/api/sampleType";
export const FILTERED_LIST = "/api/filteredData";
export const LOGIN = "/api/login";
export const ADD_NEW_DATA = "/api/addNew";
export const GET_ALL_CITIES = "/api/cities";
export const ALL_SAMPLE_LIST = "/api/allSampleTypeLists";
export const ALL_DISEASE_LIST = "/api/allDiseaseList";
export const GET_PACKAGE_INCLUSION = "/api/fetchInclusion";

export const GET_REPORT_NEW = "/api/getReportUrl"

export const NEW_IT_DOSE_REPORT_API = 'https://report.apollodiagnostics.in/Apollo/design/onlinelab/DummyReportAPI.aspx'